import { render, staticRenderFns } from "./TotalRingChart.vue?vue&type=template&id=156f7d54&scoped=true&"
import script from "./TotalRingChart.vue?vue&type=script&lang=js&"
export * from "./TotalRingChart.vue?vue&type=script&lang=js&"
import style0 from "./TotalRingChart.vue?vue&type=style&index=0&lang=less&"
import style1 from "./TotalRingChart.vue?vue&type=style&index=1&id=156f7d54&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "156f7d54",
  null
  
)

export default component.exports